module.exports = __webpack_public_path__ + "static/media/producer-cam-mute-icon.a51b5362.svg";